/* eslint no-bitwise: ["error", { "allow": ["<<", "|"] }] */
const IntegrationElement = {
  None: 0,
  HideTopBar: 1 << 0,
  HideControlPanel: 1 << 1,
  HideBreadCrumb: 1 << 2,
  HideHeader: 1 << 3,
  LinkRedirect: 1 << 4,
  ShowHomeButton: 1 << 5,
  HideMyActiviesHeader: 1 << 6,
  HideDefaultHomeLink: 1 << 7,
  RedirectToDetails: 1 << 8,
  ShowMobileAppHeader: 1 << 9
};

const IntegrationMode = {
  Teams:
    IntegrationElement.HideTopBar |
    IntegrationElement.HideControlPanel |
    IntegrationElement.HideBreadCrumb |
    IntegrationElement.HideHeader |
    IntegrationElement.LinkRedirect |
    IntegrationElement.ShowHomeButton |
    IntegrationElement.HideMyActiviesHeader |
    IntegrationElement.HideDefaultHomeLink |
    IntegrationElement.RedirectToDetails,
  Mobile:
    IntegrationElement.HideTopBar |
    IntegrationElement.HideControlPanel |
    IntegrationElement.HideBreadCrumb |
    IntegrationElement.HideHeader |
    IntegrationElement.LinkRedirect |
    IntegrationElement.HideMyActiviesHeader |
    IntegrationElement.HideDefaultHomeLink |
    IntegrationElement.RedirectToDetails |
    IntegrationElement.ShowMobileAppHeader,
  Normal: IntegrationElement.None
};

export { IntegrationMode, IntegrationElement };
